var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenueLoss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#EFDEFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3924_42735",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3924_42735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1 28.05C16.7333 27.4167 16.4583 26.7667 16.275 26.1C16.0917 25.4333 16 24.75 16 24.05C16 21.8167 16.775 19.9167 18.325 18.35C19.875 16.7833 21.7667 16 24 16H24.175L22.575 14.4L23.975 13L27.975 17L23.975 21L22.575 19.6L24.175 18H24C22.3333 18 20.9167 18.5875 19.75 19.7625C18.5833 20.9375 18 22.3667 18 24.05C18 24.4833 18.05 24.9083 18.15 25.325C18.25 25.7417 18.4 26.15 18.6 26.55L17.1 28.05ZM24.025 35L20.025 31L24.025 27L25.425 28.4L23.825 30H24C25.6667 30 27.0833 29.4125 28.25 28.2375C29.4167 27.0625 30 25.6333 30 23.95C30 23.5167 29.95 23.0917 29.85 22.675C29.75 22.2583 29.6 21.85 29.4 21.45L30.9 19.95C31.2667 20.5833 31.5417 21.2333 31.725 21.9C31.9083 22.5667 32 23.25 32 23.95C32 26.1833 31.225 28.0833 29.675 29.65C28.125 31.2167 26.2333 32 24 32H23.825L25.425 33.6L24.025 35Z",
    fill: "#9B51E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueLoss);
export default __webpack_public_path__ + "static/media/RevenueLoss.8d9f400ee47270934870c413671dc727.svg";
export { ForwardRef as ReactComponent };